



















































































import { Component, Watch, Vue, Prop } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { patrolManagementServe } from '@/api/installServer';
import TaskAbnormalDialog1 from '@/views/patrolManagement/devicePatrolTask/unit/taskAbnormalDialog1.vue';
import dayjs from 'dayjs';

@Component({
  components: {
    TaskAbnormalDialog1,
  },
})
export default class DetailPage extends Vue {
  @Prop() row!: any;

  private form: any = {
    loading: false,
    deviceName: '',
    devicePosition: '',
    staffName: '',
    shouldPatrolFrequency: '',
    realPatrolFrequency: '',
    patrolFrequencyNum: '',
    patrolRecordList: [],
    finishRate: 0, //
  };
  private taskData = {
    id: '',
    name: '',
    lineId: '',
    startTime: '',
    endTime: '',
    staffList: [
      {
        id: '',
        name: '',
      },
    ],
    pointList: [
      {
        id: '',
        pointId: '',
        pointName: '',
        replaceVisible: false,
      },
    ],
  };
  private pointList: any = [];
  private id: any = '';

  private determineDate(startTime?: any, endTime?: any) {
    const startDate = new Date(startTime);
    const endDate = new Date(endTime);
    const nowDate: any = new Date();
    if (startDate.getTime() - nowDate.getTime() > 0) {
      return 'notStarted'; // 未开始 notStarted
    } else if (nowDate.getTime() - endDate.getTime() > 0) {
      return 'overtime'; // 超时 overtime
    } else {
      return 'normal';
    }
  }

  async created() {
    if (this.row.id) {
      this.id = this.row.id;
      await this.getTaskData(this.row.id);
    }
  }

  openWarningData(data: any) {
    const taskAbnormalDialogComponent: any = this.$refs['taskAbnormalDialog'];
    taskAbnormalDialogComponent.showAddDialog(data);
  }

  /**
   * 【按钮】返回按钮
   * @Params
   * @return
   **/
  handleCancelBtnClick() {
    this.$emit('on-response');
    // this.$router.push({
    //   name: 'PatrolTask', query: {
    //     search: this.filterForm.search || '',
    //     status: this.filterForm.status || null,
    //     date: this.filterForm.date || [],
    //     pageNo: this.filterForm.pageNo || 1,
    //     pageSize: this.filterForm.pageSize || 10
    //   }
    // });
  }

  handleSelectionChange(val: any) {
    this.pointList = val;
  }

  async getTaskData(id: string) {
    this.form.loading = true;
    try {
      const res: any = await patrolManagementServe.devicePatrolTaskDetail(id);
      if (res.code !== '200') {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
      this.form = res.data;
      this.form.finishRate = Number(((this.form.realPatrolFrequency / this.form.shouldPatrolFrequency) * 100).toFixed(2));
      this.form.loading = false;
      return res;
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【监听】监听部门选择组件值
   */
  @Watch('form.time')
  onDepartmentIdPathChanged(val: string[], oldVal: string[]) {
    if (val.length > 0) {
      this.form.startTime = val[0];
      this.form.endTime = val[1].slice(0, 10) + ' 23:59:59';
    } else {
      this.form.startTime = '';
      this.form.endTime = '';
    }
  }
}
